var _defs, _rect, _rect2, _rect3, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFalkonSmsBirdOutlook(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Falkon_SMS_Bird",
    "data-name": "Falkon SMS Bird",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 85.512,
    height: 60.02,
    viewBox: "0 0 85.512 60.02",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.499,
    x2: 1,
    y2: 0.499,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffb800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#ffad00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#ff9400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#ff8500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff8000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    y1: 0.5,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1798",
    "data-name": "Rectangle 1798",
    width: 15.606,
    height: 5.865,
    rx: 2.932,
    transform: "translate(9.748 4.153)",
    fill: "#1450ff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1799",
    "data-name": "Rectangle 1799",
    width: 15.606,
    height: 5.865,
    rx: 2.932,
    transform: "translate(9.759 36.683)",
    fill: "#1450ff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1800",
    "data-name": "Rectangle 1800",
    width: 15.606,
    height: 5.865,
    rx: 2.932,
    transform: "translate(0 20.316)",
    fill: "url(#linear-gradient)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2260",
    "data-name": "Path 2260",
    d: "M549.508,227.524c-7.472-1.992-12.057,1.735-19.208,3.2l12.581,12.6a6.152,6.152,0,0,1,1.678,3.01c.075-.268.16-.514.235-.728,5.1-14.418,14.334-9.822,14.334-9.822S557.258,229.581,549.508,227.524Z",
    transform: "translate(-473.616 -217.159)",
    fill: "url(#linear-gradient-2)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2261",
    "data-name": "Path 2261",
    d: "M205.043,136.909l25.312,24.111a5,5,0,0,1,.182,7.07l-25.729,27.132a1.069,1.069,0,0,1-1.839-.707l-.289-11.568-21.709-20.662a5.01,5.01,0,0,1-.171-7.07l17.188-18.124a4.974,4.974,0,0,1,7.055-.182Zm5.569,34.041a3.435,3.435,0,1,0-.128-4.863A3.426,3.426,0,0,0,210.612,170.95Zm-7.461-7.112a3.435,3.435,0,1,0-.128-4.863A3.426,3.426,0,0,0,203.151,163.837Zm-7.461-7.1a3.433,3.433,0,1,0-1.074-2.4A3.426,3.426,0,0,0,195.69,156.736Z",
    transform: "translate(-160.245 -135.53)",
    fill: "#1450ff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFalkonSmsBirdOutlook);
export default __webpack_public_path__ + "static/media/Falkon-SMS-Bird-Outlook.db184d2096ff2cb95ec66e1daaab9975.svg";
export { ForwardRef as ReactComponent };